module.exports = new __parcel__URL__("mercenary_wolvez_hideout_level_1.a8a2b443.png").toString();